import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { HubCardDef } from "../../navigation/appNavigation";

function HubCardLeadingGraphic({ graphic }: { graphic: HubCardDef["icon"] }) {
    if (graphic.kind === "fontawesome") {
        return <FontAwesomeIcon icon={graphic.icon} className="fa-2x mb-2 text-primary" />;
    }
    if (graphic.kind === "inlineSvg") {
        const Svg = graphic.Svg;
        return (
            <Svg
                className="mb-2 d-block text-primary"
                style={{ height: "2em", width: "auto" }}
                aria-hidden
                focusable="false"
            />
        );
    }
    return (
        <img
            src={graphic.src}
            alt={graphic.alt ?? ""}
            className="mb-2 d-block"
            style={{ height: "2em", width: "auto" }}
            decoding="async"
        />
    );
}

type Props = {
    cards: HubCardDef[];
};

export function HubCardGrid({ cards }: Props) {
    return (
        <Row className="g-3 mt-2">
            {cards.map((card) => (
                <Col key={card.to} xs={12} md={6} lg={4}>
                    <Link className="text-decoration-none" to={card.to}>
                        <Card className="bg-light shadow h-100">
                            <Card.Body>
                                <HubCardLeadingGraphic graphic={card.icon} />
                                <Card.Title>{card.title}</Card.Title>
                                <Card.Text className="text-muted small">{card.description}</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            ))}
        </Row>
    );
}
